module.exports = __webpack_public_path__ + "img/loader.3545917f.gif";